const hhTimer = setInterval(function() {
  const hhCountdownElement = document.getElementById("fomo-count-down-timer");
  if(hhCountdownElement == null) {
    return;
  }
  const now = new Date().getTime();
  const countDownDate = new Date(hhCountdownElement.dataset.enddate).getTime();
  const distance = countDownDate - now;
  
  if (distance <= 0) {
    document.getElementById("fomo-cd-expired").style.display = 'block';
    document.getElementById("fomo-cd-timer").style.display = 'none';
    clearInterval(hhTimer);
  } else {
    document.getElementById("fomo-cd-expired").style.display = 'none';
    document.getElementById("fomo-cd-timer").style.display = 'block';
    document.getElementById("timer-sec").innerText = Math.floor((distance / 1000) % 60);
    document.getElementById("timer-min").innerText = Math.floor((distance / 1000 / 60) % 60);
    document.getElementById("timer-hrs").innerText = Math.floor((distance / (1000 * 60 * 60)) % 24);
    document.getElementById("timer-day").innerText = Math.floor(distance / (1000 * 60 * 60 * 24));
  }
  hhCountdownElement.style.display = 'block';
}, 1000);